<template>
  <v-row>
    <v-col xs="12" sm="12" style="justify-content: center; align-items: center">
    </v-col>
    <v-col xs="12" sm="12" style="justify-content: center; align-items: center">
      <v-carousel
        v-model="currentPage"
        :cycle="cycle"
        vertical-delimiters="true"
        hide-delimiters
        :interval="slideInterval"
        class="fill-height"
        @change="pageChanged"
        hide-delimiter-background
        show-arrows-on-hover
        light
      >
        <template v-slot:prev="{ on, attrs }">
          <v-btn color="success" v-bind="attrs" v-on="on">Previous slide</v-btn>
        </template>
        <template v-slot:next="{ on, attrs }">
          <v-btn color="info" v-bind="attrs" v-on="on">Next slide</v-btn>
        </template>
        <v-carousel-item>
          <div class="welcome-header align-center text-center">
            <h1
              style="
                justify-content: center;
                align-items: center;
                text-align: center;
                font-weight: 300;
              "
            >
              <span style="font-weight: 400">Sei stanco </span> di ... ?
            </h1>
          </div>
          <v-divider class="header-divider"></v-divider>
        </v-carousel-item>

        <!--<v-carousel-item>
          <div class="welcome-header align-center text-center">
            <h1
              style="
                justify-content: center;
                align-items: center;
                text-align: center;
                font-weight: 300;
              "
            >
              <span style="font-weight: 400">Sei stanco </span> di ... ?
            </h1>
          </div>
          <v-divider class="header-divider"></v-divider>
        </v-carousel-item>-->

        <v-carousel-item>
          <div class="welcome-header align-center text-center">
            <h1
              style="
                justify-content: center;
                align-items: center;
                text-align: center;
                font-weight: 300;
              "
            >
              <span style="font-weight: 400"> Cambia</span> modo di pianificare!
            </h1>
          </div>
          <v-divider class="header-divider"></v-divider>
        </v-carousel-item>
        <v-carousel-item>
          <div class="welcome-header align-center text-center">
            <h1
              style="
                justify-content: center;
                align-items: center;
                text-align: center;
                font-weight: 300;
              "
            >
              Scegli un
              <span style="font-weight: 400">planner last generation</span> che
              sia
            </h1>
          </div>
          <v-divider class="header-divider"></v-divider>
        </v-carousel-item>
        <v-carousel-item>
          <div class="welcome-header align-center text-center">
            <h1
              style="
                justify-content: center;
                align-items: center;
                text-align: center;
                font-weight: 400;
              "
            >
              Semplice
            </h1>
          </div>
          <v-divider class="header-divider"></v-divider>
        </v-carousel-item>
        <v-carousel-item>
          <div class="welcome-header align-center text-center">
            <h1
              style="
                justify-content: center;
                align-items: center;
                text-align: center;
                font-weight: 400;
              "
            >
              Veloce
            </h1>
          </div>
          <v-divider class="header-divider"></v-divider>
        </v-carousel-item>
        <v-carousel-item>
          <div class="welcome-header align-center text-center">
            <h1
              style="
                justify-content: center;
                align-items: center;
                text-align: center;
                font-weight: 400;
              "
            >
              Rivoluzionario!
            </h1>
          </div>
          <v-divider class="header-divider"></v-divider>
        </v-carousel-item>
        <v-carousel-item>
          <div class="welcome-header align-center text-center">
            <h1
              style="
                justify-content: center;
                align-items: center;
                text-align: center;
                font-weight: 400;
              "
            >
              Scegli
            </h1>
          </div>
          <v-divider class="header-divider"></v-divider>
        </v-carousel-item>

        <v-carousel-item>
          <div class="welcome-header">
            <h1
              style="
                justify-content: center;
                align-items: center;
                text-align: center;
                font-size: 30px;
              "
            >
              <span style="font-weight: 300">Easy</span>
              <span style="font-weight: 400">Planner</span>
            </h1>
            <v-img
              lazy-src="@/img/img-logo-only.png"
              src="@/img/img-logo-only.png"
              height="150px"
              contain
              color="transparent"
              alt="EASYPLANNER"
            ></v-img>
          </div>

          <v-divider class="header-divider"></v-divider>

          <div class="welcome-page-contents">
            <h1
              style="
                justify-content: center;
                align-items: center;
                text-align: center;
                font-weight: 300;
              "
            >
              Pianificare non è mai stato così semplice.
            </h1>
            <h1></h1>
            <h1></h1>
            <h2
              style="
                justify-content: center;
                align-items: center;
                text-align: center;
                font-weight: 100;
              "
            ></h2>
          </div>
        </v-carousel-item>

        <!-- <v-carousel-item>
          <div class="welcome-header">
            <v-img
              lazy-src="@/img/img-logo-only.png"
              src="@/img/img-logo-only.png"
              height="150px"
              contain
              color="transparent"
              alt="EASYPLANNER"
            ></v-img>
            <h1
              style="
                justify-content: center;
                align-items: center;
                text-align: center;
                font-size: 30px;
              "
            >
              <span style="font-weight: 300">Easy</span> <b>Planner</b>
            </h1>
          </div>

          <v-divider style="margin: 20px"></v-divider>

          <div class="welcome-page-contents">
            <h1
              style="
                justify-content: center;
                align-items: center;
                text-align: center;
                font-weight: 100;
              "
            >
              <b>Cocaina:</b>
            </h1>
            <h1
              style="
                justify-content: center;
                align-items: center;
                text-align: center;
                font-weight: 100;
              "
            >
              La cocaina ti aiuterà a rimanere concentrato più intensamente e
              più a lungo (oltre 12 ore continuative) inoltre, ti renderà più
              loquace facendoti apparire più estroverso e quindi più
              apprezzabile agli occhi del tuo capo
            </h1>
          </div>
        </v-carousel-item>

        <v-carousel-item>
          <div class="welcome-header">
            <v-img
              lazy-src="@/img/img-logo-only.png"
              src="@/img/img-logo-only.png"
              height="150px"
              contain
              color="transparent"
              alt="EASYPLANNER"
            ></v-img>
            <h1
              style="
                justify-content: center;
                align-items: center;
                text-align: center;
                font-size: 30px;
              "
            >
              <span style="font-weight: 300">Easy</span> <b>Planner</b>
            </h1>
          </div>
          <v-divider style="margin: 20px"></v-divider>
          <div class="welcome-page-contents">
            <h1
              style="
                justify-content: center;
                align-items: center;
                text-align: center;
                font-weight: 100;
              "
            >
              <b>Mariwana:</b>
            </h1>
            <h1
              style="
                justify-content: center;
                align-items: center;
                text-align: center;
                font-weight: 100;
              "
            >
              La mariwana ti aiuterà a rilassarti quando avrai finito il tuo
              turno di lavoro e ti aiuterà a non pensare che lavori oltre 12 ore
              al giorno anche se sei assunto come part-time e non ti pagano gli
              straordinari.
            </h1>
          </div>
        </v-carousel-item> -->
      </v-carousel>
    </v-col>
  </v-row>
</template>
<style lang="scss">
.header-divider {
  margin: 20px;
  background: #cf1818;
}

#navbar-right {
}
#particles-js {
  width: 100%;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 0;
}
.mainPage[isMobile] #frm-login {
  position: fixed;
  top: 0px;
  left: 0px;
  border-radius: 0 !important;
  right: 0;
  bottom: 0;
}
</style>

<script>
export default {
  props: {
    slidePage: { default: -1, type: Number },
  },
  data() {
    return {
      currentPage: 0,
      cycle: true,
      slideInterval: 4000,
    };
  },
  mounted() {
    if (this.slidePage > -1) {
      // this.slideInterval = 1;
      this.cycle = false;
      this.currentPage = this.slidePage;
    }
  },
  computed: {},
  methods: {
    pageChanged(a, b) {
      if (this.slidePage == -1) {
        if (a == 0 || a == 1 || a == 2 || a == 3) this.slideInterval = 3000;
        else if (a == 6) this.slideInterval = 2000;
        else this.slideInterval = 1500;
        if (a == 8 || a == this.slidePage) this.cycle = false;
      } else if (a == this.slidePage) this.cycle = false;
    },
  },
  components: {},
};
</script>
